import { render, staticRenderFns } from "./BaseSelectInput.vue?vue&type=template&id=5cb8ef69&scoped=true&"
import script from "./BaseSelectInput.vue?vue&type=script&lang=js&"
export * from "./BaseSelectInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb8ef69",
  null
  
)

export default component.exports